import { css } from '@emotion/react';
import { Button, Form, Space, Table, TableColumnsType } from 'antd';
import { TargetIndividualSearcher } from '../../forms/nutritional-menu-calculator-management/target-individual-search.form';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { TableRowSelection } from 'antd/es/table/interface';

import {
    watchDetailFoodById,
} from '@/redux/slices/food.slice';

import {
    watchPaginationFilterTargetProfile,
    watchLoadingFilterTargetProfile,
    getListTargetProfile,
    watchListTargetProfile,
} from '@/redux/slices/nutritional-menu-calculator.slice';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useEffect, useState } from 'react';

type PageChangeParams = {
    offset?: number;
    pageSize?: number;
    filter?: FilterTargetProfileNutritionalMenuCalculator;
};

type FoodInformationModalProps = {
    onCancel: () => void;
    setSelectedRow: any;
    selectedRow?: TargetProfileListNutritionalMenuCalculator | null;
};

export const TargetIndividualModal = ({
    onCancel,
    setSelectedRow,
    selectedRow
}: FoodInformationModalProps) => {
    const [form] = Form.useForm();
    const detailFood = useAppSelector(watchDetailFoodById);
    const [selectedRecord, setSelectedRecord] = useState<TargetProfileListNutritionalMenuCalculator | null>(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const pagination = useAppSelector(watchPaginationFilterTargetProfile);
    const loading = useAppSelector(watchLoadingFilterTargetProfile);
    const [filter, setFilter] = useState<FilterTargetProfileNutritionalMenuCalculator>({});
    const dataSource = useAppSelector(watchListTargetProfile);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (detailFood) {
            form.setFieldsValue(detailFood);
        }
    }, [detailFood, form]);

    const onEdit = () => {
        onCancel();
        setSelectedRow(selectedRecord);
    }

    const handlePageChange = useCallback(
        ({
            offset = PAGINATION_PARAMS.offset,
            pageSize = PAGINATION_PARAMS.limit,
            filter
        }: PageChangeParams) => {
            dispatch(getListTargetProfile({ query: filter, offset, limit: pageSize }));
        },
        [dispatch]
    );

    const handleSearch = (values: FilterTargetProfileNutritionalMenuCalculator) => {
        const newFilter = {
            ...filter,
            ...values
        };
        setFilter(newFilter);
        handlePageChange({ filter: newFilter });
    };

    useEffect(() => {
        if (selectedRow) {
            setSelectedRowKeys([selectedRow.PROFILE_ID]);
            setSelectedRecord(selectedRow);
        }
    }, [selectedRow]);

    const rowSelection: TableRowSelection<TargetProfileListNutritionalMenuCalculator> = {
        type: 'radio',
        selectedRowKeys,
        columnTitle: 'Chọn',
        onChange: (newSelectedRowKeys, selectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRecord(selectedRows[0] ?? null);
        },
    };

    const columns: TableColumnsType<TargetProfileListNutritionalMenuCalculator> = [
        {
            title: 'STT',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Tình trạng sức khỏe',
            dataIndex: 'healthCondition',
            key: 'healthCondition',
            width: 200,
            fixed: 'left',

        },
        {
            title: 'Giới tính',
            dataIndex: 'GENDER_NAME',
            key: 'GENDER_NAME',
            width: 100,
        },
        {
            title: 'Cân nặng (Kg)',
            dataIndex: 'PROFILE_WEIGHT_MAX',
            key: 'PROFILE_WEIGHT_MAX',
            width: 200,
        },
        {
            title: 'Tình trạng dinh dưỡng theo Zcore (cân nặng theo tuổi)',
            dataIndex: 'ZSCORE_DESCRIPTION',
            key: 'ZSCORE_DESCRIPTION',
            width: 300,
        },
        {
            title: 'Tình trạng dinh dưỡng theo BMI đối với trẻ từ 5 (trên 60 tháng) đến 19 tuổi',
            dataIndex: 'BMI_60_19_DESCRIPTION',
            key: 'BMI_60_19_DESCRIPTION',
            width: 300,
        },
        {
            title: 'Hoạt động thể lực',
            dataIndex: 'ACTIVITY_VALUE',
            key: 'ACTIVITY_VALUE',
            width: 150,
        },
        {
            title: 'Hệ thống lao động',
            dataIndex: 'LABOR_SYSTEM',
            key: 'LABOR_SYSTEM',
            width: 150,
        },
        {
            title: 'Tiêu chuẩn năng lượng/ngày (kcal)',
            width: 150,
            children: [
                {
                    title: 'min',
                    dataIndex: 'MIN_STANDARD_ENERGY',
                    key: 'MIN_STANDARD_ENERGY',
                    width: 150,
                },
                {
                    title: 'max',
                    dataIndex: 'MAX_STANDARD_ENERGY',
                    key: 'MAX_STANDARD_ENERGY',
                    width: 150,
                }
            ]
        },
        {
            title: 'Số bửa ăn/ ngày',
            dataIndex: 'meal',
            key: 'meal',
            width: 150,
        },
    ];

    return (
        <div css={rootStyles}>

            <TargetIndividualSearcher handleSearch={handleSearch} />

            <Table<TargetProfileListNutritionalMenuCalculator>
                rowKey="PROFILE_ID"
                rowSelection={rowSelection}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    showQuickJumper: false,
                    showSizeChanger: true,
                    current: pagination.curPage,
                    pageSize: pagination.limitPage,
                    total: pagination.totalRows,
                    onChange: (offset, pageSize) => {
                        handlePageChange({ offset, pageSize });
                    }
                }}
            />
            <Space css={groupButtonStyles}>
                <Button type='default' size='large' onClick={onCancel}>
                    Đóng
                </Button>
                <Button type='primary' size='large' onClick={onEdit}>
                    Chỉnh sửa
                </Button>
            </Space>
        </div>
    );
};

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-top: 1.6rem;

  button {
    padding: 2rem 4rem;
  }
`;

const rootStyles = css`
  background: var(--white-soft-color);
  display: flex;
  flex-direction: column;
  /* gap: 1.4rem; */
  //   min-height: calc(70vh - var(--header-height));
  min-height: auto !important;
  .css-c01d5x .ant-form-item .ant-form-item-label>label {
    font-size: 14px; !important;
  }

  .ant-table-row {
  padding: 2px 2px;
  }
   .ant-table-cell {
      padding: 2px 2px !important;
    }
`;
